import { LogCannon } from '@ace-clublabs/log-cannon';

export const createAxiosConfig = (scenario: string | null | undefined, endpoint: string) => {
  const headers = {
    'X-Ace-Session-Id': LogCannon.getSessionId(),
  };
  const isProd = endpoint.search('api.ace.aaa.com') > -1;
  if (isProd || !scenario) {
    return {
      headers,
    };
  }
  return {
    headers: {
      ...headers,
      'X-Ace-Mock': scenario ? 'true' : 'false',
      'X-Ace-Test-Scenario': scenario ? scenario : undefined,
    },
  };
};
